// レビュー一覧APIの契約。src/server/product-review/types.ts の ProductReviewResponse と対。

export type ProductReviewItem = {
  id: number
  entryDate: string
  products: string
  body: string
}

export type ProductReviewResponse = {
  ok: boolean
  items: ProductReviewItem[]
  hasMore: boolean
}

/** ページを跨ぐカーソル。前ページ最後の item をそのまま渡す。 */
export type ProductReviewCursor = { id: number; entryDate: string }

export async function fetchReviews(
  api: string,
  siteId: number,
  cursor: ProductReviewCursor | null,
  pageSize: number,
): Promise<ProductReviewResponse> {
  // data-api にローカル検証用の相対パスを渡せるよう、location を base にする
  // （本番は絶対URLを渡す想定で base は無視される。order-status ウィジェットと同じ作法）。
  const url = new URL(api, location.href)
  url.searchParams.set('siteId', String(siteId))
  url.searchParams.set('pageSize', String(pageSize))
  if (cursor) {
    url.searchParams.set('beforeId', String(cursor.id))
    url.searchParams.set('beforeDate', cursor.entryDate)
  }

  const r = await fetch(url, { cache: 'no-store' })
  if (!r.ok) throw new Error(`status ${r.status}`)
  return (await r.json()) as ProductReviewResponse
}
